/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { KeywordScanResponseDTOFromJSON, KeywordScanResponseDTOToJSON, } from './KeywordScanResponseDTO';
/**
 * Check if a given object implements the PaginatedResponseKeywordScanResponseDTO interface.
 */
export function instanceOfPaginatedResponseKeywordScanResponseDTO(value) {
    return true;
}
export function PaginatedResponseKeywordScanResponseDTOFromJSON(json) {
    return PaginatedResponseKeywordScanResponseDTOFromJSONTyped(json, false);
}
export function PaginatedResponseKeywordScanResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'items': json['items'] == null ? undefined : (json['items'].map(KeywordScanResponseDTOFromJSON)),
    };
}
export function PaginatedResponseKeywordScanResponseDTOToJSON(json) {
    return PaginatedResponseKeywordScanResponseDTOToJSONTyped(json, false);
}
export function PaginatedResponseKeywordScanResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'currentPage': value['currentPage'],
        'totalCount': value['totalCount'],
        'items': value['items'] == null ? undefined : (value['items'].map(KeywordScanResponseDTOToJSON)),
    };
}
